import { v1 as uuidv1 } from 'uuid';

import { getCurrentStateChainConfig } from '#/config/configUtils';
import { KatanaExchange_v2__factory } from '#/lib/ethereum/contracts/contractsFromSdk';
import { uuidToHexString } from '#/lib/string';
import { DelegatedKeyAuthorization } from '#/reduxState/delegatedKey/authorizationReducer';

import { clearGlobalEnforcedChainId } from '../chains';

import { triggerWalletChainSwitchIfPossible } from './switchEthereumChain';
import { getUncheckedWalletRPCProvider } from './utils';

import { getSigner, getUncheckedSigner } from './index';

import type { IWallet } from '#/reduxState/wallet/walletReducer';

async function getWalletSigner(
  wallet: IWallet,
  delegatedWallet?: DelegatedKeyAuthorization,
  estimation = false
) {
  return estimation
    ? getUncheckedWalletRPCProvider(wallet.walletAddress)
    : getSigner(wallet, delegatedWallet);
}

/**
 * Invalidates a nonce, which must be a valid uuid.  This can be used to invalidate order or
 * delegated key nonces.
 */
export async function invalidateNonceOnContract(
  wallet: IWallet,
  exchangeContract?: string,
  nonce: string = uuidv1()
) {
  if (!exchangeContract) {
    throw new Error('Unknown Exchange Contract Address');
  }

  await triggerWalletChainSwitchIfPossible(
    wallet.walletType,
    getCurrentStateChainConfig(),
    await getUncheckedSigner(wallet)
  );
  clearGlobalEnforcedChainId();

  const signer = await getWalletSigner(wallet);

  const exchange = KatanaExchange_v2__factory.connect(
    exchangeContract,
    // @ts-expect-error TS6 ethers dual-package types (lib.esm vs lib.commonjs)
    signer
  );

  return await exchange.invalidateNonce(uuidToHexString(nonce));
}
